import { postLikeFolder } from './postLikeFolder';
import { getLikedFolders } from './getLikedFolders';
import { deleteLikedFolder } from './deleteLikedFolder';
import { putLikedFolder } from './putLikedFolder';
import { editLikedFoldersOrder } from './editLikedFoldersOrder';
import { getFolderDetailMeta } from './getFolderDetailMeta';
import { getFolderDetail } from './getFolderDetail';
import { getFolderDetailCategories } from './getFolderDetailCategories';
import { uploadCoverImage } from './uploadCoverImage';

export const likedFolderService = {
  get: getLikedFolders,
  post: postLikeFolder,
  put: putLikedFolder,
  delete: deleteLikedFolder,
  editOrder: editLikedFoldersOrder,
  getFolderDetailMeta,
  getFolderDetail,
  getFolderDetailCategories,
  uploadCoverImage,
};
